import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OtpRetryState {
  retryAt: number | null;
  setRetryAt: (iso: string | null) => void;
}

/**
 * `skipHydration` avoids a hydration mismatch: SSR always renders with `retryAt: null`, so the
 * store only reads localStorage once mounted, via `.persist.rehydrate()`.
 *
 * One factory instance per OTP flow — sharing a single store across flows lets one flow's
 * countdown clobber another's (a practitioner mid-verification in one tab, mid-sign-in-with-code
 * in another).
 */
export const createOtpRetryStore = (name: string) =>
  create<OtpRetryState>()(
    persist(
      (set) => ({
        retryAt: null,
        setRetryAt: (iso) => set({ retryAt: iso ? new Date(iso).getTime() : null }),
      }),
      { name, skipHydration: true },
    ),
  );

export const useOtpRetryStore = createOtpRetryStore("email-verification-retry-at");
export const useSignInCodeRetryStore = createOtpRetryStore("sign-in-with-code-retry-at");
